const sessionCache = {
  set(key, value) {
    if (!sessionStorage) {
      return
    }
    if (key != null && value != null) {
      sessionStorage.setItem(key, value)
    }
  },
  get(key) {
    if (!sessionStorage) {
      return null
    }
    if (key == null) {
      return null
    }
    return sessionStorage.getItem(key)
  },
  setJSON(key, jsonValue) {
    if (jsonValue != null) {
      this.set(key, JSON.stringify(jsonValue))
    }
  },
  getJSON(key) {
    const value = this.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
  },
  remove(key) {
    sessionStorage.removeItem(key)
  },
}
const localCache = {
  set(key, value) {
    if (!localStorage) {
      return
    }
    if (key != null && value != null) {
      localStorage.setItem(key, value)
    }
  },
  get(key) {
    if (!localStorage) {
      return null
    }
    if (key == null) {
      return null
    }
    return this.getItem(key)
  },
  setJSON(key, jsonValue) {
    if (jsonValue != null) {
      this.set(key, JSON.stringify(jsonValue))
    }
  },
  getJSON(key) {
    const value = this.get(key)
    if (value != null) {
      return JSON.parse(value)
    }
  },
  remove(key) {
    localStorage.removeItem(key)
  },
  // 检测缓存是否存在
  has(key) {
    return localStorage.getItem(key) ? true : false
  },
  setItem(params) {
    let obj = {
      name: '',
      value: '',
      expires: '',
      startTime: new Date().getTime(),
    }
    let options = {}
    //将obj和传进来的params合并
    Object.assign(options, obj, params)
    if (options.expires) {
      //如果options.expires设置了的话
      //以options.name为key，options为值放进去
      localStorage.setItem(options.name, JSON.stringify(options))
    } else {
      //如果options.expires没有设置，就判断一下value的类型
      //let type = Object.prototype.toString.call(options.value)
      //如果value是对象或者数组对象的类型，就先用JSON.stringify转一下，再存进去
      if (Object.prototype.toString.call(options.value) == '[object Object]') {
        options.value = JSON.stringify(options.value)
      }
      if (Object.prototype.toString.call(options.value) == '[object Array]') {
        options.value = JSON.stringify(options.value)
      }
      localStorage.setItem(options.name, options.value)
    }
  },

  // 获取数值
  getItem(name) {
    let item = localStorage.getItem(name)
    // 判断 item 是否存在
    if (item) {
      // 先将取到的对象 看能转换成object 对象格式，不能就说明不是json字符串形式
      try {
        item = JSON.parse(item)
      } catch (error) {
        //item = item
        return item
      }
      // 如果有expires的值,说明设置了失效时间
      if (item.expires) {
        // 获取当前时间
        let now = new Date().getTime()
        // 当前的时间和存入时候的时间 进行相减 和过期时间进行比较
        // 大于就说明过期了 清除存储  小于或者等于 就没有过期
        if (now - item.startTime > item.expires) {
          localStorage.removeItem(name)
          return null // 返回一个状态值
        } else {
          //缓存未过期，返回值
          return item.value
        }
      } else {
        // 没有设置过期时间，直接返回值
        return item
      }
    } else {
      return null // 如果item 值为undefined 则说明没有存储 返回false
    }
  },
}

export default {
  /**
   * 会话级缓存
   */
  session: sessionCache,
  /**
   * 本地缓存
   */
  local: localCache,
}
